module.exports = __webpack_public_path__ + "img/warning.42a13894.svg";